
    import { defineComponent } from "vue";
    import NetServices from '@/tools/netservices';
    import GetLanguage from '@/tools/language';
    import GeneralFx from '@/tools/general_fx';

    const language =GetLanguage(),
        appFxs = GeneralFx();
    
    
    export default defineComponent({
        name: 'ProdStockBalance',
        props: ["productSku"],
        data(){
            return {
                language,
                appFxs,
                isStillLoading: true,
                balanceStockProduct: 0,
            }
        },
        mounted(){
            NetServices.requestGet(`products/products/getbalanceprodinstock/${this.productSku}`)
                .then(oRes => {
                    if(!oRes.bReturn){
                        this.balanceStockProduct = 0;
                        this.isStillLoading = false;
                        return;
                    }
                    
                    this.isStillLoading = false;
                    this.balanceStockProduct = oRes.balanceStockProduct!;
                });
        }
    })
